var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path9, _ellipse, _ellipse2, _ellipse3, _path10, _path11, _path12, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _path13, _path14, _polygon6, _path15, _path16, _path17, _path18, _path19, _path20, _polygon7, _path21, _path22, _path23, _path24, _path25, _path26, _polygon8, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _circle, _path35, _path36, _path37, _path38, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUndrawSoftwareEngineerReFyew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 802.60505,
    height: 507.21872,
    viewBox: "0 0 802.60505 507.21872",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M905.44724,660.26007l.78168-17.57605a56.76523,56.76523,0,0,1,26.47721-6.7024c-12.71655,10.39671-11.12737,30.438-19.74889,44.41914a34.14441,34.14441,0,0,1-25.03847,15.77861l-10.64165,6.51555a57.21522,57.21522,0,0,1,12.05952-46.36368,55.26712,55.26712,0,0,1,10.157-9.4375C902.04232,653.61415,905.44724,660.26007,905.44724,660.26007Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M367.49652,640.99976l-25.68043-7.77505a86.57236,86.57236,0,0,1,.06719-41.65383c10.57528,22.709,40.79195,27.90877,58.20681,45.916a52.07339,52.07339,0,0,1,13.888,42.946l5.621,18.18084a87.25864,87.25864,0,0,1-63.97667-35.28461,84.287,84.287,0,0,1-10.12173-18.56506C356.39239,643.52862,367.49652,640.99976,367.49652,640.99976Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M816.464,699.82086a2.038,2.038,0,0,1-.59,1.42,1.98776,1.98776,0,0,1-1.41.58h-8.04a1.99311,1.99311,0,0,1-2-2v-243.14c0-5.36-1.8-9.71-4.01-9.72H299.924c-2.22.00994-4.01,4.36-4.02,9.72v241.65a2.00629,2.00629,0,0,1-1.81,1.99c-1.62.16-3.24.3-4.85.43-.04,0-.08.01-.12.01-.88.08-1.76.14-2.64.21h-.01c-.46-.83-.9-1.68-1.35-2.53a2.08782,2.08782,0,0,1-.22-.93v-253.44c0-1.48.06-2.97.16-4.44a56.85312,56.85312,0,0,1,.75-6.02c1.69-9.29,5.51-15.58,9.85-15.6h509a4.683,4.683,0,0,1,1.84.39,7.1738,7.1738,0,0,1,2.27,1.59,14.07182,14.07182,0,0,1,2.23,3.05c2.13995,3.77,3.67,9.39,4.21,15.93,0,.06.01.12.01.18.14,1.62.21,3.27.2,4.92l.14,21.43.09,12.78.27,40.1.1,14.24Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M630.71488,343.8771H579.70929a2.72143,2.72143,0,0,0-2.71732,2.72432v80.57382H633.4392V346.60142A2.72289,2.72289,0,0,0,630.71488,343.8771Zm-25.3312,45.78106a6.0512,6.0512,0,0,1-6.02293-6.02289v-9.29349a6.02291,6.02291,0,0,1,12.04582,0v9.29349a6.0511,6.0511,0,0,1-6.02289,6.02289Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#ccc"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M576.81689,424.598v7.77378a1.52285,1.52285,0,0,0,1.51976,1.51972h53.75791a1.52739,1.52739,0,0,0,1.51972-1.51972V424.598Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M715.17556,218.13256h-218.029a7.07768,7.07768,0,0,0-7.06642,7.06638V372.32585a7.07318,7.07318,0,0,0,7.06642,7.06638h218.029a7.07318,7.07318,0,0,0,7.06642-7.06638V225.19894A7.07768,7.07768,0,0,0,715.17556,218.13256Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M713.35564,223.2365H498.96813a3.78733,3.78733,0,0,0-3.7791,3.787V370.50368a3.78562,3.78562,0,0,0,3.7791,3.7791H713.35564a3.78562,3.78562,0,0,0,3.7791-3.7791V227.02347A3.78733,3.78733,0,0,0,713.35564,223.2365Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M671.59659,436.59655H544.0477a2.34634,2.34634,0,0,1-2.296-2.82966l1.97915-9.39973a2.35647,2.35647,0,0,1,2.29565-1.86291H669.61782a2.35645,2.35645,0,0,1,2.29564,1.86291l1.97916,9.39973a2.34634,2.34634,0,0,1-2.296,2.82966Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 348.23475,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 356.09152,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 363.94828,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 371.80504,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 379.66181,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 387.51857,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 395.37533,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 403.2321,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 411.08886,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 418.94563,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 426.80239,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 434.65915,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 442.51592,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 450.37268,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 458.22945,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 466.08621,
    y: 227.80619,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 348.14191,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 355.99868,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 363.85544,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 371.7122,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 379.56897,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 387.42573,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 395.2825,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 403.13926,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 410.99602,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 418.85279,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 426.70955,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 434.56632,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 442.42308,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 450.27984,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 458.13661,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 465.99337,
    y: 231.73457,
    width: 3.92838,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 385.85438,
    y: 236.44863,
    width: 31.42706,
    height: 2.35703,
    rx: 0.48819,
    fill: "#e6e6e6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M702.57875,243.00487H501.97721a.79793.79793,0,0,1,0-1.59547H702.57875a.79793.79793,0,0,1,0,1.59547Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#cacaca"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 316.93494,
    cy: 36.16639,
    rx: 4.67511,
    ry: 4.7793,
    fill: "#ccc"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 333.08532,
    cy: 36.16639,
    rx: 4.67511,
    ry: 4.7793,
    fill: "#ccc"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 349.23571,
    cy: 36.16639,
    rx: 4.67511,
    ry: 4.7793,
    fill: "#ccc"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M692.85485,228.96233H681.38246a.86884.86884,0,0,0,0,1.73733h11.47239a.86884.86884,0,0,0,0-1.73733Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#ccc"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M692.85485,232.223H681.38246a.86884.86884,0,0,0,0,1.73733h11.47239a.86884.86884,0,0,0,0-1.73733Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#ccc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M692.85485,235.47946H681.38246a.86884.86884,0,0,0,0,1.73733h11.47239a.86884.86884,0,0,0,0-1.73733Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "403.375 58.71 402.727 56.817 485.585 13.765 486.232 15.658 403.375 58.71",
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "653.375 138.452 652.727 136.559 702.585 93.725 703.232 95.617 653.375 138.452",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "557.585 148.423 474.727 105.371 475.375 103.478 558.232 146.53 557.585 148.423",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "600 118.465 551.425 38.719 552.96 37.436 601.534 117.182 600 118.465",
    fill: "#3f3d56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "637.908 14.554 590.601 14.336 590.601 12.336 637.908 12.554 637.908 14.554",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M922.30253,223.35012h-53a13,13,0,0,1,0-26h53a13,13,0,0,1,0,26Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#117aca"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M988.30253,299.35012h-53a13,13,0,0,1,0-26h53a13,13,0,0,1,0,26Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#117aca"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "703.908 156.553 656.601 156.336 656.601 154.336 703.908 154.553 703.908 156.553",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M988.30253,365.35012h-53a13,13,0,0,1,0-26h53a13,13,0,0,1,0,26Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#117aca"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M833.30253,356.39064h-53a13,13,0,0,1,0-26h53a13,13,0,0,1,0,26Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#117aca"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M761.30253,222.39064h-53a13,13,0,0,1,0-26h53a13,13,0,0,1,0,26Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#117aca"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M507.974,445.57086h-60a8,8,0,0,0,0,16h22v62h16v-62h22a8,8,0,0,0,0-16Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M547.57508,557.90777H387.09217a64.8054,64.8054,0,0,1-63.9165-55.63574L317.495,481.37637a469.07753,469.07753,0,0,0-53.18135-122.90313c-10.74733-17.45375-16.27894-34.34886-3.71483-50.61525q.16047-.20775.31562-.40969c10.07715-13.11621,60.23438-15.95556,76.58545-16.50781q.969-.033,1.94531-.03272h99.81885q.97705,0,1.94482.03272a48.84661,48.84661,0,0,1,42.23633,26.9209,50.33119,50.33119,0,0,1-2.856,51.52978c-35.06348,52.6709-45.79883,85.69727-34.80811,107.085,10.63135,20.6875,43.22021,31.26465,102.55859,33.28516,15.94629.543,23.26465,12.96,23.31592,24.2666.04981,11.01465-6.98633,23.17578-22.55273,23.84766Q548.34413,557.90777,547.57508,557.90777Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M414.35471,700.40767h60a8,8,0,1,0,0-16h-22v-135h-16v135h-22a8,8,0,0,0,0,16Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#3f3d56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.963 449.592 280.299 455.206 307.661 417.375 292.405 409.088 269.963 449.592",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M473.63578,632.50172l18.764,5.87565-2.98659,7.861L502.28,664.9131a5.25274,5.25274,0,0,1-6.19089,7.891l-21.84388-8.299-.81093-9.20623L469.01,662.51612l-8.236-3.12905Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M494.77578,264.46621a11.61439,11.61439,0,0,1-11.86091,13.28494l-39.85133,84.79529L430.5647,345.11677l41.02391-80.18115a11.67734,11.67734,0,0,1,23.18717-.46941Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M362.526,379.69125s-1.06794,14.81358,15.68515,17.719,61.53907-25.415,68.8943-29.76356,21.06173-59.0606,21.06173-59.0606L456.247,288.42426c-14.71742,18.61693-26.27484,35.784-26.97661,47.97Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#117aca"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M381.86674,430.71785l3.61818,15.54612s.03555,14.3349,2.57427,16.978c2.52095,2.6308,57.95539-2.6514,57.95539-2.6514s-5.87747-23.09971-5.79929-40.57842Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#a0616a"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M498.974,629.57086l-20-11c-.3804-26.02478,15.27313-61.24347,33.83954-98.13245-41.523,7.1413-80.69613,9.429-114.57919.79014a21.9013,21.9013,0,0,1-15.66277-26.45771q.19783-.82229.45751-1.62713c4.05515-12.37248-5.03763-20.128,3.32559-33.73606,21.9964-7.51227,42.89209-9.63366,62-3L460.32711,482.879l59.3425-7.67911a21.88181,21.88181,0,0,1,24.3436,19.29367q.11962.96629.1563,1.94043C532.17042,552.68671,518.71583,603.30255,498.974,629.57086Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M373.81134,332.29485l22.861-1.34981a4.641,4.641,0,0,1,4.56391,2.8632l6.46044,15.66164L434.54688,371.662s10.63071,13.528,10.65544,30.99911,3.77169,57.9098,3.77169,57.9098-15.515-21.83866-25.09122-16.03024c-1.62919.98818-2.20224,3.009-3.90878,4.03024-.85124.50941-2.81783.01422-3.67748.52453-13.19586,7.83347-26.95778,15.48647-28.24366,14.14459-2.52471-2.63468-5.58735-16.09762-5.58735-16.09762l-20.92619-76.88718a28.47663,28.47663,0,0,1,4.04936-23.96177c1.46193-2.05832,2.99367-3.58959,4.41713-3.84286C373.202,341.77,371.50184,334.60665,373.81134,332.29485Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#117aca"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "369.583 482.16 379.233 475.451 357.372 434.207 343.13 444.109 369.583 482.16",
    fill: "#a0616a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M569.73907,650.877l-15.12358,13.51825c-24.04779-26.79566-42.22732-64.37578-57.63343-107.05272-40.36583-11.82219-70.807-30.88836-97.38186-53.5265-9.01533-7.6285-15.77355-17.42855-8.08468-26.72119q.53918-.65163,1.126-1.2603c9.07832-9.33,32.10064-7.552,45.58458-16.09964l30.12136,32.19638-1.89465,8.63161L523.03,519.72776a21.8522,21.8522,0,0,1,13.33557,28.01716q-.31785.92028-.71351,1.81124Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M562.65411,675.83093,578.10159,663.666l4.79986,6.90486,22.678-.06905a5.25275,5.25275,0,0,1,3.01458,9.56593l-19.18687,13.3376-8.05494-4.531,3.45652,7.72758-7.23422,5.02882Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M407.56959,526.06358a11.61441,11.61441,0,0,1-5.19028-17.03619L350.625,430.92577,372.01127,429.3l47.20245,76.70664a11.67734,11.67734,0,0,1-11.64413,20.0569Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#a0616a"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M377.81256,353.20142s-12.10319-8.60787-23.28869,4.19807-10.25152,65.78667-10.35663,74.33057c-.03291,2.67542,3.83043,8.44836,9.15312,15.1166,2.38959,2.99366,5.07331,6.16777,7.83066,9.32305,1.59565,1.82592.22076,5.62645,1.823,7.40115,1.59343,1.765,6.16418,1.50458,7.67983,3.14269,7.19414,7.77543,13.0386,13.69412,13.0386,13.69412l23.42024.288c.26422-17.41016-11.65851-32.95069-26.97577-47.97046Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#117aca"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M354.20548,277.39843c-2.21731,1.60039-4.55,3.24914-7.25562,3.64571s-5.87315-.91138-6.62192-3.54141c-.91552-3.21574,1.98827-6.14372,4.59815-8.23362l8.2759-6.627a20.01043,20.01043,0,0,1,5.0741-3.2807,6.76231,6.76231,0,0,1,5.85435.19572,6.287,6.287,0,0,1,2.76309,5.47358,11.68687,11.68687,0,0,1-2.04962,5.99576,21.08857,21.08857,0,0,1-13.69111,9.30674",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M416.974,449.57086h-60a8,8,0,0,0,0,16h22v62h16v-62h22a8,8,0,0,0,0-16Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#3f3d56"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M357.88155,260.61415c.24143-5.99814-6.15036-10.74763-12.13979-10.37217s-11.13819,4.58845-14.53481,9.53775c-3.39557,4.94513-5.43542,10.673-8.11051,16.04228s-6.23745,10.62635-11.55322,13.40875c-5.31472,2.77823-12.71285,2.28252-16.38635-2.461a13.20771,13.20771,0,0,0-1.35659,11.86531,18.08784,18.08784,0,0,0,7.93819,9.21092,20.79688,20.79688,0,0,0,4.596,2.021,18.7147,18.7147,0,0,1,2.76622-4.97493,15.45067,15.45067,0,0,0-.59565,5.50673,18.38756,18.38756,0,0,0,7.4903-.118,15.94506,15.94506,0,0,0,11.06173-9.02126c2.24643-5.31776,1.10225-11.38082,1.58271-17.13318.4763-5.75343,3.94328-12.32134,9.716-12.41513,4.3964-.07233,3.81449.29014,6.6,3.69174",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M397.80253,292.13256a26,26,0,0,1-26,26c-14.35941,0-28-16.6406-28-31s13.64059-21,28-21A26,26,0,0,1,397.80253,292.13256Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 379.64229,
    cy: 298.98895,
    r: 24.8051,
    transform: "translate(-250.92799 -114.21621) rotate(-11.56418)",
    fill: "#a0616a"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M410.80253,295.13256c-7.343,2.005-14.75693,4.10672-17.62,0a22.578,22.578,0,0,0-3.11-7.66,31.01406,31.01406,0,0,1-1.83,7.66c-9.277,2.01648-17.94754,2.4985-25.44,0a14.20407,14.20407,0,0,0-1.75,6.06,8.5511,8.5511,0,0,0-1.16-.61,1.91861,1.91861,0,0,0-1.58-.14,1.36441,1.36441,0,0,0-.65,1.01,3.77151,3.77151,0,0,0,.06,1.25,9.50266,9.50266,0,0,0,1.25,4.06,3.70266,3.70266,0,0,0,2.51,1.61c1.04,5.85,9.32,13.76,9.32,13.76-25,1-25-15.96-25-32l3-6h10v-13h28A24.00619,24.00619,0,0,1,410.80253,295.13256Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#2f2e41"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M638.63816,703.302l-438.75.30734a1.19069,1.19069,0,1,1,0-2.38137l438.75-.30733a1.19068,1.19068,0,0,1,0,2.38136Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#cacaca"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M931.63816,703.302l-226.75.30734a1.19069,1.19069,0,1,1,0-2.38137l226.75-.30733a1.19068,1.19068,0,1,1,0,2.38136Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#cacaca"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M648.66554,344.39064H562.71241A13.53851,13.53851,0,0,1,549.189,330.8672V273.91408a13.53852,13.53852,0,0,1,13.52343-13.52344h85.95313A13.53852,13.53852,0,0,1,662.189,273.91408V330.8672A13.53852,13.53852,0,0,1,648.66554,344.39064Zm-85.95313-82A11.53654,11.53654,0,0,0,551.189,273.91408V330.8672a11.53654,11.53654,0,0,0,11.52343,11.52344h85.95313A11.53654,11.53654,0,0,0,660.189,330.8672V273.91408a11.53655,11.53655,0,0,0-11.52344-11.52344Z",
    transform: "translate(-198.69747 -196.39064)",
    fill: "#e6e6e6"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 366.4915,
    y: 82,
    width: 22.99121,
    height: 2,
    fill: "#e6e6e6"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 366.4915,
    y: 90,
    width: 51,
    height: 2,
    fill: "#e6e6e6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 366.4915,
    y: 97,
    width: 51,
    height: 2,
    fill: "#e6e6e6"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 366.4915,
    y: 104,
    width: 65,
    height: 2,
    fill: "#e6e6e6"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 366.4915,
    y: 111,
    width: 34,
    height: 2,
    fill: "#e6e6e6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 366.4915,
    y: 118,
    width: 62,
    height: 2,
    fill: "#e6e6e6"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 366.4915,
    y: 125,
    width: 11,
    height: 2,
    fill: "#e6e6e6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawSoftwareEngineerReFyew);
export default __webpack_public_path__ + "static/media/undraw_software_engineer_re_fyew.ff6721ccaf8a0b44d4afe402a9ca073d.svg";
export { ForwardRef as ReactComponent };